import { render, staticRenderFns } from "./ProductsInStockLocationsSidebar.vue?vue&type=template&id=e35df4c0&scoped=true"
import script from "./ProductsInStockLocationsSidebar.vue?vue&type=script&lang=js"
export * from "./ProductsInStockLocationsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductsInStockLocationsSidebar.vue?vue&type=style&index=0&id=e35df4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35df4c0",
  null
  
)

export default component.exports